exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-detail[data-v-7b95fce5] {\n  min-width: 100px !important;\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n.action-span[data-v-7b95fce5] {\n  display: inline-block;\n  margin-right: 10px;\n  color: #0077fa;\n}\n", ""]);

// exports
